import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    layout: {
      namespaced: true,
      state: {
        mobile: window.matchMedia("(max-width:767px)").matches,
        modal: {
          currentContent:"mock-up",
          title: "",
          show: false,
        },
        isScrolled: 0,
        isMvpModalOpen: false,
        language: 'en',
      },
      mutations: {
        SET_MODAL_TITLE(state, payload) {
          state.modal.title = payload.title;
        },
        SET_MODAL_VISIBILITY(state) {
          state.modal.show = !state.modal.show;
        },
        SET_MODAL_CONTENT(state, payload) {
          state.modal.currentContent = payload.content;
        },
        SET_IS_SCROLLED(state, payload) {
          state.isScrolled = payload.scrolled;
        },
        SET_MVP_MODAL_VISIBILITY(state) {
          state.isMvpModalOpen = !state.isMvpModalOpen;
        },
        SET_LANGUAGE(state, payload) {
          state.language = payload.language;
        },
      },
      actions: {
        updateModalTitle({ commit } , { payload }) {
          commit('SET_MODAL_TITLE', payload);
        },
        updateModalVisibility({ commit } , { payload }) {
          commit('SET_MODAL_VISIBILITY', payload);
        },
        updateModalContent({ commit } , { payload }) {
          commit('SET_MODAL_CONTENT', payload);
        },
        updateIsScrolled({ commit } , { payload }) {
          commit('SET_IS_SCROLLED', payload);
        },
        updateMvpModalVisibility({ commit }) {
          commit('SET_MVP_MODAL_VISIBILITY');
        },
        setLanguage({ commit } , { payload }) {
          commit('SET_LANGUAGE', payload);
        },
      },
      getters: {
        modal (state) {
          return state.modal;
        },
        mobile (state) {
          return state.mobile;
        },
        isScrolled (state) {
          return state.isScrolled;
        },
        isMvpModalOpen (state) {
          return state.isMvpModalOpen;
        },
      },
    },
  },
});

export default store;
